import React from "react";
import "./loader.css";

export default function Loader({ isLoading }) {
  if (isLoading) {
    return (
      <div className="overlay">
        <div className="loader" />
      </div>
    );
  }
}
